const applyStaticCSS = (renderer, cssFiles = []) => {
    if (cssFiles.length === 0) return;

    const cssString = cssFiles.reduce((acc, item) => acc + item.toString(), '');
    renderer.renderStatic(cssString);
};

export default applyStaticCSS;
